// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"d6839f50","665":"2e603cc6","701":"3bd6a506"}[chunkId] + ".chunk.js";
};